
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../../../Helper/Loading'
import { STPMPCBTestDeleteAPI, STPMPCBTestExportDataAPI, STPMPCBTestTableDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveMPCBTestSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import STPMPCBTestDataPopup from './STPPreventiveMPCBTestDataPopup'
import { STPPreventiveMPCBTestExportData } from './STPPreventiveMPCBTestExportData'
import { TableNote } from '../../../../../../Components/Note/Note'

export default function STPPreventiveMPCBTestData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPMPCBTestPopupShow, setSTPMPCBTestPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    // const handleAddOnClick = () => {
    //     console.log("add")
    //     setSTPEquipmentMasterPopupShow(true)
    // }

    const handleEditOnClick = (item) => {
        setSTPMPCBTestPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setSTPMPCBTestPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })

        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }


    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_UserID: UserID,
            Flag: 'Grid',
            token: token,
            From: From,
            To: To,
            handleSTPMPCBTestExport: handleSTPMPCBTestExport
        }
        dispatch(STPMPCBTestTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.STPMPCBTestTableData)

    const handleSTPMPCBTestExport = () => {
        const data = {
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_UserID: UserID,
            Flag: 'Report',
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(STPMPCBTestExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPMPCBTestTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_STP_MPCBTestID: item.t_stP_MPCBTestID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPMPCBTestDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.STPMPCBTestDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>MPCB Test</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <STPPreventiveMPCBTestExportData
                                                ExcelData={ExportTableData}
                                                name='MPCB Test'
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-6">
                                                <label for=""><b>From Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="FromDate"
                                                    value={FromDate}
                                                    onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-6">
                                                <label for=""><b>To Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={ToDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    min={FromDate}
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />
                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1 mb-5">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Reading Date</th>
                                                        <th>MPCB Parameter</th>
                                                        <th>Unit</th>
                                                        <th>Result Value</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.mpcbParameter ? item.mpcbParameter : '-'}</td>
                                                                <td>{item.unit ? item.unit : '-'}</td>
                                                                <td style={{ textAlign: "right", width: '10%' }}>{item.resultValue ? item.resultValue : '0'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span>
                                                                                    <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => handleEditOnClick(item)}
                                                                                    >
                                                                                    </i>
                                                                                </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        item={item}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={6}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    STPMPCBTestPopupShow ?
                        <STPMPCBTestDataPopup
                            open={STPMPCBTestPopupShow}
                            popupHeading="Work Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>

    )
}